import { VENDOR_LIST } from '../constants/vendors.const'

export const findVendorById = (id) => {
  return VENDOR_LIST.find(vendorData => vendorData.id === id)
}

export const findVendorBySrc = (src) => {
  if (typeof src !== 'string') {
    return
  }
  return VENDOR_LIST.find(vendorData => {
    let result = false
    vendorData.urls.forEach(url => {
      if (url.endsWith('/')) {
        result = result || new RegExp('^' + url + '[^/]+$').test(src)
      } else {
        result = result || src.startsWith(url)
      }
    })
    return result
  })
}

export const findCookieInVendor = (vendor, cookieName) => {
  if (!vendor || !vendor.cookies || !cookieName) {
    return null
  }
  return vendor.cookies.find(vendorCookie => {
    if (vendorCookie.name.indexOf('*') > -1) {
      const regexp = new RegExp(vendorCookie.name.replace(/\*/g, '.+'))
      return regexp.test(cookieName)
    }
    return cookieName === vendorCookie.name
  })
}

export const findVendorByCookie = (cookieName) => {
  return VENDOR_LIST.find(vendorData => findCookieInVendor(vendorData, cookieName))
}
